import groupBy from 'lodash/groupBy';
import sortBy from 'lodash/sortBy';

import type { MultipleChoiceAnswerFragment } from '../../present/activity-answers.graphql.generated';
import type { GetClassStudentAnswersQuery } from '../../present/activity-answers.graphql.generated';
import { ClassroomResult } from '../classroom.constants';
import type { Pluck } from 'lib/gql/pluck';

export function prepareClassResults({
  studentAnswers,
  options,
}: {
  studentAnswers: Pluck<
    GetClassStudentAnswersQuery,
    'getClassStudentsAnswers'
  >[];
  options: {
    itemId: string | null;
    correctAnswerBoolean: boolean;
    sort: string | null;
  }[];
}): ClassroomResult[] {
  const groupedByStudentId = groupBy(studentAnswers, 'studentId');
  const sortedOptions = sortBy(options, 'sort');

  return sortedOptions.map(option => {
    const totalResponses = Object.values(groupedByStudentId).reduce(
      (total, student) => {
        const answers = (
          student[0].answer as MultipleChoiceAnswerFragment
        ).multipleChoiceItems.filter(answer => answer.isSelected);

        return total + (answers.some(a => a.itemId === option.itemId) ? 1 : 0);
      },
      0
    );

    return {
      itemId: option.itemId,
      isCorrect: option.correctAnswerBoolean,
      total: totalResponses,
    };
  });
}
